import {
    get,
    post,
    importData
} from '@/utils/request'

const SERVICE_URL = '/mdata-service/v1'

export function deletePart(params, pathParam) {
    return get(SERVICE_URL + '/part/deletePart', params, pathParam)
}
export function queryById(params, pathParam) {
    return get(SERVICE_URL + '/part/getById', params, pathParam)
}
export function partList(params) {
    return post(SERVICE_URL + '/part/page', params)
}
export function createPart(params) {
    return post(SERVICE_URL + '/part/createPart', params)
}
export function editPart(params) {
    return post(SERVICE_URL + '/part/updatePart', params)
}
export function importFile(params) {
    return importData(SERVICE_URL + '/part/import', params)
}


/**物料分类管理 */
export function fetchMtlForMainBody(params, pathParam) {return post(SERVICE_URL + '/mdMtl/listMainBodyMtl', params)}
export function createMtl(params) {return post(SERVICE_URL + '/mdMtl/add', params)}
export function editMtl(params) {return post(SERVICE_URL + '/mdMtl/edit', params)}
export function deleteMtl(params, pathParam) {return get(SERVICE_URL + '/mdMtl/deleteMtl', params, pathParam)}
export function fetchMtlClass(params, pathParam) {return post(SERVICE_URL + '/mdMtl/listMainBodyMtlAll', params)}
export function fetchMtlClassByIds(params, pathParam) {return post(SERVICE_URL + '/mdMtl/fetchMtlClassByIds', params)}


/**配额申请管理**/
export function selectQuotaApplyPage(params) {return post(SERVICE_URL + '/quotaApply/selectQuotaApplyPage', params)}
export function deleteQuotaApply(params) {return get(SERVICE_URL + '/quotaApply/deleteQuotaApply', params)}
export function saveQuota(params) {return post(SERVICE_URL + '/quotaApply/saveQuota', params)}
export function executeQuotaApply(params) {return post(SERVICE_URL + '/quotaApply/executeQuotaApply', params)}
export function quotaApprove(params) {return post(SERVICE_URL + '/quotaApply/quotaApprove', params)}
export function queryQuotaMaterialByApplyId(params) {return post(SERVICE_URL + '/quotaApply/queryQuotaMaterialByApplyId', params)}


